import React, { useEffect, useState, useContext } from 'react'
import Button from '../../elements/button/Button'

import { PLAY_PROPS } from './interface'
import { red, blue } from '../helpers/gradients'
import PlayButtonContent from './PlayButtonContent'
import { MyContext } from '../../../context/createContext'
import { sendStakes } from '../../../settings/useSettings'

function PlayButton({
  finalStake,
  autoRollNumber,
  autoReady,
  diceSocketMessages,
  playClick,
  startAuto,
  betCount,
  handleStartAuto,
  setisDisablePlay,
  isDisablePlay,
  prec,
}: PLAY_PROPS) {
  const [isDisabled, setIsDisabled] = useState(finalStake.toString() === '0')
  const { context } = useContext(MyContext)
  const { handleManualConfigs, sliderValue, stake, auth, rollUnder, settings } =
    context
  const {
    balance: { currency },
  } = auth

  const [rollUnderValue, setRollUnder] = useState<any>(rollUnder)
  const handlePlay = () => {
    autoReady ? '' : updateManuals()
    playClick()
    setisDisablePlay(true)
    if (autoReady) {
      startAuto ? handleStartAuto(false) : handleStartAuto(true)
    } else {
      sendStakes(stake, sliderValue, rollUnder == '0' ? 0 : 1, settings)
      diceSocketMessages.placeBet(stake, sliderValue, rollUnder == '0' ? 0 : 1)
    }
    // !autoReady ? diceSocketMessages.handleBet(stake, sliderValue, rollUnder) : startAuto ? handleStartAuto(false) : handleStartAuto(true)
  }
  const updateManuals = () => {
    handleManualConfigs({ stake, sliderValue, rollUnder })
  }

  useEffect(() => {
    setIsDisabled(finalStake.toString() === '0')
  }, [finalStake])

  useEffect(() => {
    if (rollUnder == '1') {
      setRollUnder('1')
    } else if (rollUnder == '0') setRollUnder('0')
    else setRollUnder(rollUnder)
  }, [rollUnder])

  return (
    <Button
      size='26px'
      width='100%'
      background={rollUnderValue == '0' ? red : blue}
      isDisabled={isDisabled || isDisablePlay}
      stakeColor={rollUnderValue == '0' ? '#FFB7B7' : '#A3B5FF'}
      font='Regular'
      func={() => handlePlay()}
    >
      <PlayButtonContent
        autoReady={autoReady}
        autoRollNumber={autoRollNumber}
        finalStake={finalStake}
        currency={currency}
        rollUnder={rollUnderValue == '1'}
        startAuto={startAuto}
        betCount={betCount}
        prec={prec}
      />
    </Button>
  )
}
export default PlayButton
